<template>
    <g class="legend" :transform="`translate(${transform.x}, ${transform.y})`">
        <!-- left top -->
        <template v-if="isLeftTop">
            <rect v-for="(key, index) in yKeys" :key="`legend-rect-${index}`"
                :x="boundary.minX"
                :y="boundary.padding + (legendSize * 1.5 * index) + (legendPadding * index)"
                :width="legendSize * 1.5"
                :height="legendSize * 1.5"
                :fill="colors ? colors[key] : `url(#${pathArray[index].id})`"
            ></rect>
            <text v-for="(key, index) in yKeys" :key="`legend-text-${index}`"
                :style="`font-size:${legendSize}`"
                :x="boundary.minX + legendPadding + (legendSize * 1.5)"
                :y="boundary.padding + (legendSize * 1.5 * index) + (legendPadding * index) + (legendSize * 1.5 * legendPadding/3)"
                :fill="labelColor"
            >
                <slot name="legend" :item="{ key }">
                    <!-- {{ key }} -->
                </slot>
            </text>
        </template>
        <!-- left bottom -->
        <template v-if="isLeftBottom">
            <rect v-for="(key, index) in yKeyReverse" :key="`legend-rect-${index}`"
                :x="boundary.minX"
                :y="boundary.maxY - (legendSize * 1.5 * index) - (legendPadding * index) - (legendSize * 1.5)"
                :width="legendSize * 1.5"
                :height="legendSize * 1.5"
                :fill="colors ? colors[key] : `url(#${pathArray[yKeys.length - 1 - index].id})`"
            ></rect>
            <text v-for="(key, index) in yKeyReverse" :key="`legend-text-${index}`"
                :style="`font-size:${legendSize}`"
                :x="boundary.minX + legendPadding + (legendSize * 1.5)"
                :y="boundary.maxY - (legendSize * 1.5 * index) - (legendPadding * index) - (legendSize * 1.5 * 1/3)"
                :fill="labelColor"
            >
                <slot name="legend" :item="{ key }">
                    {{ key }}
                </slot>
            </text>
        </template>
        <!-- right top  -->
        <template v-if="isRightTop">
            <rect v-for="(key, index) in yKeys" :key="`legend-rect-${index}`"
                :x="boundary.maxX - (boundary.padding * 2) - fontWidth - legendSize"
                :y="boundary.padding + (legendSize * 1.5 * index) + (legendPadding * index)"
                :width="legendSize * 1.5"
                :height="legendSize * 1.5"
                :fill="colors ? colors[key] : `url(#${pathArray[index].id})`"
            ></rect>
            <text v-for="(key, index) in yKeys" :key="`legend-text-${index}`"
                :style="`font-size:${legendSize}`"
                :x="boundary.maxX - (boundary.padding * 2) - fontWidth - legendSize + legendPadding + (legendSize * 1.5)"
                :y="boundary.padding + (legendSize * 1.5 * index) + (legendPadding * index) + (legendSize * 1.5 * legendPadding / 3)"
                :fill="labelColor"
            >
                <slot name="legend" :item="{ key }">
                    {{ key }}
                </slot>
            </text>
        </template>
        <!-- right bottom -->
        <template v-if="isRightBottom">
            <rect v-for="(key, index) in yKeyReverse" :key="`legend-rect-${index}`"
                :x="boundary.maxX - (boundary.padding * 2) - fontWidth - legendSize"
                :y="boundary.maxY - (legendSize * 1.5 * index) - (legendPadding * index) - (legendSize * 1.5)"
                :width="legendSize * 1.5"
                :height="legendSize * 1.5"
                :fill="colors ? colors[key] : `url(#${pathArray[yKeys.length - 1 - index].id})`"
            ></rect>
            <text v-for="(key, index) in yKeyReverse" :key="`legend-text-${index}`"
                :style="`font-size:${legendSize}`"
                :x="boundary.maxX - (boundary.padding * 2) - fontWidth - legendSize + legendPadding + (legendSize * 1.5)"
                :y="boundary.maxY - (legendSize * 1.5 * index) - (legendPadding * index) - (legendSize * 1.5 * 1/3)"
                :fill="labelColor"
            >
                <slot name="legend" :item="{ key }">
                    {{ key }}
                </slot>
            </text>
        </template>
    </g>
</template>

<script>
export default {
    props: [
        'data',
        'yKeys',
        'legendSize',
        'legendPadding',
        'legendDirection',
        'boundary',
        'colors',
        'labelColor'
    ],
    computed: {
        transform () {
            if (this.isLeftTop || this.isRightTop) {
                return {
                    x: this.legendPadding,
                    y: this.legendPadding
                }
            } else if (this.isLeftBottom || this.isRightBottom) {
                return {
                    x: this.legendPadding,
                    y: -this.legendPadding
                }
            } else {
                return {
                    x: 0,
                    y: 0
                }
            }
        },
        fontWidth () {
            const maxLen = Math.max.apply(null, this.yKeys.map(key => key.length))
            return maxLen * this.legendSize / 2
        },
        pathArray () {
            return this.data
        },
        yKeyReverse () {
            return this.yKeys.slice().reverse()
        },
        isLeftTop () {
            return this.legendDirection === 'left-top'
        },
        isLeftBottom () {
            return this.legendDirection === 'left-bottom'
        },
        isRightTop () {
            return this.legendDirection === 'right-top'
        },
        isRightBottom () {
            return this.legendDirection === 'right-bottom'
        }
    }
}
</script>

<style>

</style>
